









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

import { PhoneNumberDetails } from '@/models/phone-number-details';
import { Constants } from '@/common/Constants';

@Component({
	components: {
		VueTelInput,
	},
})
export default class UserPhoneInput extends Vue {
	@Prop({ required: false, type: String, default: '' })
	private userPhone!: string | null;

	@Prop({ required: false, type: Boolean, default: false })
	public disabled!: boolean;

	public get allowedCountries(): string[] {
		return Constants.SUPPORTED_COUNTRY_CODES;
	}

	public setPhone(phone: string | null): void {
		this.phoneNumber = phone ?? '';
	}

	@Emit('phoneChanged')
	public onInput(
		phone: string,
		phoneObject: PhoneNumberDetails,
	): {
		phone: string;
		phoneObject: PhoneNumberDetails;
	} {
		return { phone, phoneObject };
	}

	public phoneNumber: string = this.userPhone ?? '';
}
